import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { isEditActiveSelector } from "../../../reducers/editReducer";
import * as _ from "lodash";
import EditDataActCodeCommon from "../../Editing/EditDataActCodeCommon";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";


interface EscalatorDataActProps {
  columns: State.ColumnMap;
  subMenuRoute: string;
  setColumnFilters: (subMenuRoute: string, columnFilter: Filter[]) => void;
  editActions: typeof editActions;
  editedObjectId: number | undefined;
  toggleModal: () => void;
}

const EscalatorDataAct: React.FC<EscalatorDataActProps> = props => {
  const dispatch = useDispatch();
  const pdApi = useSelector((state: State.Root) => state.pdApi);
  const isLoading = useSelector((state: State.Root) => state.loadingStatus.isEscalatorDataActCodesLoading);
  const isEditActive = useSelector((state: State.Root) => isEditActiveSelector(state.editView));
  const mainState = useSelector((state: State.Root) => state.main);
  const selectedColumns = props.columns["Data Acts"];
  const handleFilterChangeDebounced = useCallback(
    _.debounce((changedFilters: Filter[]) => {
      props.setColumnFilters(props.subMenuRoute, changedFilters);
    }, 500),
    [props.setColumnFilters, props.subMenuRoute]
  );
  useEffect(() => () => handleFilterChangeDebounced.cancel(), [handleFilterChangeDebounced]);
    useEffect(() => {
      dispatch(pdApiActions.fetchEscalatorDataActCodes());
      dispatch(pdApiActions.fetchEscalatorFaults());
    }, [dispatch]);
  const isSelected = useCallback(
    (dataAct: Api.EscalatorDataActCode): boolean => props.editedObjectId === dataAct.id,
    [props.editedObjectId]
  );
  return (
    <div className="flex-1">
      <div className="flex-1">
        <Table
          startingPage={0}
          rows={pdApi.escalatorDataActCodes ? pdApi.escalatorDataActCodes : []}
          loading={isLoading}
          loadingText="Fetching Escalator Data Act codes"
          columns={selectedColumns}
          isHidingTextActive={mainState.isShortenTextEnabled}
          handleRowSelection={row => dispatch(editActions.select(row))}
          isRowSelected={isSelected}
          pageSize={mainState.pageSize}
          handleFilterChange={handleFilterChangeDebounced}
        />
      </div>
      {isEditActive && (
        <Dimmer active={true} page={true}>
          <div
            className="edit-view"
            style={{
              flex: mainState.editSize,
              width: mainState.editSize == 0.3 ? "500px" : "1000px"
            }}
          >
            <EditDataActCodeCommon toggleModal={props.toggleModal} target="Escalator" />
          </div>
        </Dimmer>
      )}
    </div>
  );
};

export default EscalatorDataAct;